import Timer from './components/Timer';
import './App.css';

function App() {
  return (
    <div className="App">
     <Timer/>
    </div>
  );
}

export default App;
